<ejs-dialog #addKeyWordDialog
            [isModal]="true"
            [showCloseIcon]="true"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.assets.asset-storage.edit-asset-storage.key-words.add' | translate}}
  </ng-template>

  <ng-template #content>
    <form [formGroup]="assetStorageAddKeyWordForm">
      <label for="name" class="control-label">{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.key-words.name' | translate }}</label>
      <input id="name" type="text" class="form-control" formControlName="name" />
      <app-error-messages [control]="assetStorageAddKeyWordForm.controls.name"></app-error-messages>
    </form>
  </ng-template>
  <ng-template #footerTemplate>
    <ng-container>
      <button class="btn btn-secondary me-2" (click)="closeDialog()">{{'i18n.shared.close' | translate}}</button>
      <button class="btn btn-primary" (click)="onSaveKeyWord()">{{'i18n.shared.save' | translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
